// src/app/HydrationRoot.tsx — root route element: runs app-wide hydration + renders the tree.
import { Outlet } from 'react-router-dom';
import { useCasesHydration } from '@/hooks';

export function HydrationRoot() {
  useCasesHydration();
  return <Outlet />;
}
